import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false);  // 禁止凍結
export const tourSlice = createSlice({
  name: 'tour',
  initialState: null,
  reducers: {
    tourUpdate: (state, action) => {
      global.token = action.payload;
      return action.payload;
    },
  },
});

/** 登入狀態 */
export const tourSelect = (state) => state.tour;
export const { tourUpdate } = tourSlice.actions;
export default tourSlice.reducer;